import { AsyncPipe, CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';
import { InplaceModule } from 'primeng/inplace';

import { TagModule } from 'primeng/tag';

import { BaseTagFragment } from '../../../../generated/graphql.generated';
import { FreyaCommonModule } from '../../../freya-common/freya-common.module';
import { SharedModule } from '../../../shared/shared.module';
import { jobToolFeature, selectJob } from '../../job-tool.reducer';

import { JobTagActions } from './job-tags.actions';
import { jobTagsFeature } from './job-tags.feature';

function formatTagName(tag: BaseTagFragment) {
  return [tag.category ? `${tag.category}:` : null, tag.name]
    .filter(Boolean)
    .join(' ');
}

function enrichTag(tag: BaseTagFragment) {
  return {
    ...tag,
    formattedName: formatTagName(tag),
  };
}

@Component({
  selector: 'app-job-tags',
  standalone: true,
  imports: [
    InplaceModule,
    AsyncPipe,
    CommonModule,
    TagModule,
    FreyaCommonModule,
    SharedModule,
  ],
  templateUrl: './job-tags.component.html',
  styleUrl: './job-tags.component.scss',
})
export class JobTagsComponent {

  public viewModel$ = this.store.select(createSelector({
    readModeTags: createSelector(
      selectJob,
      jobToolFeature.selectTagsLoading,
      jobTagsFeature.selectTags,
      (job, tagsLoading, tags) => {

        if (tagsLoading) {
          return tags.map(enrichTag);
        }

        return job ? job.tags.map(enrichTag) : []

      },
    ),
    editModeTags: createSelector(jobTagsFeature.selectTags, (tags) => tags.map(enrichTag)),
    tagSuggestions: createSelector(jobTagsFeature.selectTagSuggestions, (tags) => tags.map(enrichTag)),
    hasJobTags: createSelector(selectJob, (job) => Boolean(job?.tags?.length)),
    hasDefaultTags: createSelector(jobTagsFeature.selectDefaultTags, (defaultTags) => defaultTags.length > 0),
  }));

  public actions = JobTagActions;

  constructor(
    public store: Store,
  ) {}

}
